import React from "react";
import "../styles/ProjectCard.css";

interface ProjectCardProps {
  label: string;
  value: number;
  change: number;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ label, value, change }) => {
  const formattedValue =
    label.toLowerCase().includes("pourcentage")
      ? `${value.toLocaleString()} %`
      : value.toLocaleString();

  return (
    <div className="project-card">
      <div className="project-card-content">
        <p className="project-card-label">{label}</p>

        <p className="project-card-value">
          {formattedValue}
        </p>
      </div>

      <div className="project-card-icon">
        {/* Icône de graphique simplifié */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="green"
          width="18"
          height="18"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3v18h18" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 14l4-4 4 4 4-8" />
        </svg>
      </div>
    </div>
  );
};

export default ProjectCard;
